module.exports = __webpack_public_path__ + "img/banner1-title1.ded61f35.png";